/* SURVIVINGHUMAN — purchase language and progressive enhancements.
   No generated archive numbers, badges, or product metadata. */
(function () {
  'use strict';

  var CLAIM = 'CLAIM THE ARTIFACT';

  function productDetails() {
    return document.querySelector('body.template-product .product-details');
  }

  function replaceCTA(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll(
      'body.template-product .add-to-cart-button, body.template-product button[name="add"], body.template-product .product-form__submit, body.template-product [data-add-to-cart]'
    ).forEach(function (button) {
      if (button.disabled) return;
      var target = button.querySelector(
        '.add-to-cart-text__content > span:first-child, [data-add-to-cart-text], .button__text, .product-form__submit-text'
      );
      var text = (button.textContent || '').replace(/\s+/g, ' ').trim();
      if (target) {
        target.textContent = CLAIM;
      } else if (/add\s+to\s+(cart|bag)/i.test(text)) {
        Array.prototype.forEach.call(button.childNodes, function (node) {
          if (node.nodeType === 3 && /add\s+to/i.test(node.textContent)) node.textContent = ' ' + CLAIM + ' ';
        });
      }
      button.setAttribute('aria-label', CLAIM);
      button.dataset.shClaimApplied = 'true';
    });
  }

  function addSizeGuide() {
    var details = productDetails();
    if (!details || details.querySelector('.sh-size-guide')) return;
    var picker = details.querySelector('.variant-picker, variant-selects');
    if (!picker || (picker.textContent || '').toLowerCase().indexOf('size') === -1) return;
    var link = document.createElement('a');
    link.className = 'sh-size-guide';
    link.href = '/pages/size-guide';
    link.textContent = 'Size Guide';
    picker.insertAdjacentElement('afterend', link);
  }

  function addStory() {
    var details = productDetails();
    if (!details || details.querySelector('.sh-artifact-story')) return;
    var buy = details.querySelector('.buy-buttons-block');
    if (!buy) return;
    var candidates = Array.prototype.slice.call(details.querySelectorAll('.rte p, [class*="description"] p')).filter(function (p) {
      return (p.textContent || '').trim().length > 12 && !p.closest('.sh-artifact-story');
    });
    if (!candidates.length) return;
    var first = (candidates[0].textContent || '').trim();
    var second = candidates.slice(1, 3).map(function (p) { return (p.textContent || '').trim(); }).filter(Boolean).join(' ');
    if (!second) second = 'Every artifact carries meaning beyond the fabric. It exists for the people who keep moving.';
    var story = document.createElement('section');
    story.className = 'sh-artifact-story';
    story.innerHTML = '<article class="sh-artifact-story__item"><h3 class="sh-artifact-story__eyebrow">Not Just a Piece</h3><p></p></article><article class="sh-artifact-story__item"><h3 class="sh-artifact-story__eyebrow">Why It Exists</h3><p></p></article>';
    story.querySelectorAll('p')[0].textContent = first;
    story.querySelectorAll('p')[1].textContent = second;
    buy.insertAdjacentElement('afterend', story);
    var parent = candidates[0].closest('.rte') || candidates[0].parentElement;
    if (parent) parent.classList.add('sh-source-description-hidden');
  }

  function apply(scope) {
    if (!document.body.classList.contains('template-product')) return;
    replaceCTA(scope || document);
    addSizeGuide();
    addStory();
  }

  function init() {
    apply(document);

    /* PERF FIX (mobile-perf pass, 2026-08-11):
       Previously observed document.body with { subtree:true, characterData:true },
       which re-ran full-page querySelectorAll work on EVERY DOM mutation anywhere
       on the page (cart drawer, header, quantity changes, etc.) — a major source
       of mobile jank on the product page. Now scoped to just the product-details
       container, and characterData watching (the most expensive part) is dropped
       since it isn't needed: Shopify re-renders swap whole nodes (childList),
       they don't mutate text in place. */
    var queued = false;
    var scheduleApply = function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; apply(document); });
    };

    var details = productDetails();
    if (details && 'MutationObserver' in window) {
      var observer = new MutationObserver(scheduleApply);
      observer.observe(details, { childList: true, subtree: true });
    }

    ['variant:change', 'shopify:section:load'].forEach(function (eventName) {
      document.addEventListener(eventName, scheduleApply);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
